import { MessageCircle, Mail } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import { WHATSAPP_URL, CONTACT_EMAIL } from "@/data/translations";

/**
 * Compact "Prefer to talk first?" card shown near external CTAs so users
 * who don't want to fill anything on the external app can still reach us.
 */
const FallbackContactCard = ({ variant = "dark" }) => {
  const { t } = useLang();
  const isDark = variant === "dark";

  const wrapCls = isDark
    ? "border-[#F5F2EE]/10 bg-[#F5F2EE]/[0.03] text-[#F5F2EE]"
    : "border-[#0D1117]/10 bg-[#0D1117]/[0.02] text-[#0D1117]";

  const labelCls = isDark ? "text-[#E8A045]" : "text-[#9B7548]";

  const linkCls = isDark
    ? "text-[#F5F2EE]/85 hover:text-[#E8A045]"
    : "text-[#0D1117]/85 hover:text-[#9B7548]";

  return (
    <div
      data-testid="fallback-contact-card"
      className={`inline-flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6 border rounded-2xl px-6 py-5 ${wrapCls}`}
    >
      <div>
        <div className={`font-mono-accent text-[10px] mb-1 ${labelCls}`}>
          {t.fallback.eyebrow}
        </div>
        <div className="font-body text-sm opacity-80 max-w-xs">
          {t.fallback.sub}
        </div>
      </div>
      <div className="flex items-center gap-5 sm:pl-6 sm:border-l sm:border-current sm:border-opacity-10">
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="fallback-whatsapp"
          className={`inline-flex items-center gap-2 font-mono-accent text-[11px] transition-colors ${linkCls}`}
        >
          <MessageCircle className="w-4 h-4" strokeWidth={1.5} />
          <span>{t.fallback.whatsapp}</span>
        </a>
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          data-testid="fallback-email"
          className={`inline-flex items-center gap-2 font-mono-accent text-[11px] transition-colors ${linkCls}`}
        >
          <Mail className="w-4 h-4" strokeWidth={1.5} />
          <span>{t.fallback.email}</span>
        </a>
      </div>
    </div>
  );
};

export default FallbackContactCard;
